import useIconColor from '../../hooks/useIconColor';

const Twitter = () => {
  const { foreground, background } = useIconColor();

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M20.7738 3.31128L6.10893 20.6888H3.22681L17.8069 3.31128H20.7738Z' fill={background} />
      <path
        d='M19.8914 19.8411H16.1272L4.11694 4.15896H7.97682L19.8914 19.8411Z'
        fill={foreground}
        stroke={background}
        strokeWidth='1.69536'
      />
    </svg>
  );
};

export default Twitter;
